export default ({
    name: "Config",
    APP_NAME: "CRM_DEV_",
    API: {
        url: 'https://api.exportedu.ru',
        clientId: '8_5d6996ll854wk4os4cokow480gcw0c8ows8kck0s0cosgoswok'
    }
});
